import React from "react";
import "../css/books.css";
import sp1 from "../assets/Books/spiritual-warrior-1-e1619393110357.jpeg";
import sp2 from "../assets/Books/spiritual-warrior-2.jpeg";
import sp3 from "../assets/Books/spiritual-warrior-3.jpeg";
import sp4 from "../assets/Books/spiritual-warrior-4.jpeg";
import sp5 from "../assets/Books/spiritual-warrior-5.jpeg";
import sp6 from "../assets/Books/spiritual-warrior-6.jpeg";
import l1 from "../assets/Books/leadership-1.jpg";
import l2 from "../assets/Books/leadership-2.jpg";
import bl from "../assets/Books/black-lotus-663x1024.jpeg";
import bg1 from "../assets/Books/beggar-I.jpg";
import bg2 from "../assets/Books/beggar-II.jpg";
import bg3 from "../assets/Books/beggar-III.jpg";
import bg4 from "../assets/Books/beggar-IV.jpg";
import st1 from "../assets/Books/SacredTeachings-I.jpg";
import st2 from "../assets/Books/SacredTeachings-II.jpg";
import st3 from "../assets/Books/SacredTeachings-III.jpg";
import st4 from "../assets/Books/SacredTeachings-IV.jpg";
import st5 from "../assets/Books/SacredTeachings-V.jpg";
import st6 from "../assets/Books/SacredTeachings-VI.jpg";
import jhome from "../assets/Books/journey-home.jpg";
import jwithnin from "../assets/Books/journey-withnin.jpg";
import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";

const bookSeries = [
    {
      seriesTitle: "Spiritual Warrior Series",
      description: "The Spiritual Warrior series offers guidelines for meeting the challenges of today and becoming true spiritual warriors. They are taken from lectures given by B.T. Swami to a wide variety of live radio and television audiences around the world, as well as the author’s conversations and personal writing.",
      books: [
        {
          title: "Spiritual Warrior I",
          subtitle: "Uncovering Spiritual Truths In Psychic Phenomena",
          image: sp1,
          link: "https://www.amazon.com/Spiritual-Warrior-Uncovering-Psychic-Phenomena/dp/B087R7YN64",
        },
        {
            title: "Spiritual Warrior II",
            subtitle: "Transforming Lust into Love",
            image: sp2,
            link: "https://www.amazon.com/Spiritual-Warrior-II-Transforming-Lust-ebook/dp/B005P2DQVS",
        },
        {
            title: "Spiritual Warrior III",
            subtitle: "Solace for the Heart in Difficult Times",
            image: sp3,
            link: "https://www.amazon.com/Spiritual-Warrior-III-Solace-Difficult/dp/B087L4PDMR",
        },  
        {
          title: "Spiritual Warrior IV",
          subtitle: "Conquering the Enemies of the Mind",
          image: sp4,
          link: "https://www.amazon.com/Spiritual-Warrior-IV-Conquering-Enemies/dp/B087L33CQ5",
        },
        {
            title: "Spiritual Warrior V",
            subtitle: "Making the Mind Your Best Friend",
            image: sp5,
            link: "https://www.amazon.com/Spiritual-Warrior-Making-Your-Friend/dp/B087L5264L",
        },
        {
            title: "Spiritual Warrior VI",
            subtitle: "Beyond Fanaticism, Terrorism and War: Discover the Peace Solution",
            image: sp6,
            link: "https://www.amazon.com/Spiritual-Warrior-VI-Fanaticism-Terrorism/dp/B087LC9SP2",
        },
      ],
    },
    {
      seriesTitle: "Reflections on Sacred Teachings",
      description: "Reflections on Sacred Teachings offers profound commentaries on Vedic/Gaudiya Vaishnava scriptures like Siksastaka, Madhurya-Kadambini, and Harinama Cintamani, blending deep philosophy with practical guidance on spiritual realization, relationships, and devotion, making ancient wisdom accessible for serious practitioners.",
      books: [
        {
          title: "Reflections on Sacred Teachings I",
          subtitle: "Sri Siksastaka",
          image: st1,
          link: "https://www.amazon.com/gp/product/B088T31R2L/ref=ox_sc_act_title_6?smid=ATVPDKIKX0DER&psc=1",
        },
        {
          title: "Reflections on Sacred Teachings II",
          subtitle: "Madhurya Kadambini",
          image: st2,
          link: "https://www.amazon.com/gp/product/B087SLGL5D/ref=ox_sc_act_title_3?smid=ATVPDKIKX0DER&psc=1",
        },
        {
          title: "Reflections on Sacred Teachings III",
          subtitle: "Harinama Cintamani",
          image: st3,
          link: "https://www.amazon.com/gp/product/B087SFZ5DG/ref=ox_sc_act_title_4?smid=ATVPDKIKX0DER&psc=1",
        },
        {
          title: "Reflections on Sacred Teachings IV",
          subtitle: "Sri Isopanisad",
          image: st4,
          link: "https://www.amazon.com/gp/product/B087SMDNY3/ref=ox_sc_act_title_1?smid=ATVPDKIKX0DER&psc=1",
        },
        {
          title: "Reflections on Sacred Teachings V",
          subtitle: "Srila Bhaktisiddhanta's Sixty-four Principles for Community",
          image: st5,
          link: "https://www.amazon.com/gp/product/B087SCHH7M/ref=ox_sc_act_title_5?smid=ATVPDKIKX0DER&psc=1",
        },
        {
          title: "Reflections on Sacred Teachings VI",
          subtitle: "Radha-Sunya: Missing",
          image: st6,
          link: "https://www.amazon.com/gp/product/B087SCHH6V/ref=ox_sc_act_title_2?smid=ATVPDKIKX0DER&psc=1",
        },
      ],
    },
    {
      seriesTitle: "The Beggar Series",
      description: "The Beggar series is a collection of deeply personal prayers and meditations, presented as dialogues with God, guiding readers through spiritual concepts like humility, selflessness, compassion, and preparing for death, especially in the face of life's challenges, all written in an accessible, non-sectarian style to foster genuine spiritual connection. The four-volume series explores themes of confronting the ego (Part III), the process of dying before dying (Part IV), and seeking divine mercy, urging readers to find sanity and purpose in a stressful world by surrendering their will to the divine.",
      books: [
        {
          title: "The Beggar I",
          subtitle: "Meditations and Prayers on the Supreme Lord",
          image: bg1,
          link: "https://www.amazon.com/gp/product/1885414005/ref=ewc_pr_img_1?smid=A1QJ4UH6FW3UH1&psc=1",
        },
        {
          title: "The Beggar II",
          subtitle: "Crying Out for the Mercy",
          image: bg2,
          link: "https://www.amazon.com/gp/product/B01MT4H2MU/ref=ox_sc_act_title_1?smid=A1E2QVT4W8G9YH&psc=1",
        },
        {
          title: "The Beggar III",
          subtitle: "False Ego: The Greatest Enemy of the Spiritual Leader",
          image: bg3,
          link: "https://www.amazon.com/gp/product/1885414102/ref=ewc_pr_img_1?smid=A25PN9C66LIVCU&psc=1",
        },
        {
          title: "The Beggar IV",
          subtitle: "Die Before Dying",
          image: bg4,
          link: "https://www.amazon.com/gp/product/B088B6BD6J/ref=ewc_pr_img_1?smid=ATVPDKIKX0DER&psc=1",
        },
      ],
    },
    {
      seriesTitle: "Leadership for Higher Consciousness",
      description: "There are tens of thousands of books printed on leadership, but the science of leadership is known by a very rare few. Everyone is a leader in some sense of the term, because everyone exerts an influence that others will have to deal with. Beyond the speculation of those who think they know, and those who are experimenting to discover what makes leadership work, B.T swami encapsulates the leadership teachings from ancient vedic texts. Readers will gain a deeper appreciation of the importance and power of leadership as it applies to themselves and their endeavours.",
      books: [
        {
          title: "Leadership for Higher Consciousness I",
          subtitle: "Administration from a Metaphysical Perspective",
          image: l1,
          link: "https://www.amazon.com/Leadership-Age-Higher-Consciousness-Administration/dp/1078210713",
        },
        {
          title: "Leadership for Higher Consciousness II",
          subtitle: "Ancient Wisdom For Modern Times",
          image: l2,
          link: "https://www.amazon.com/Leadership-Age-Higher-Consciousness-Vol/dp/1885414129",
        },
      ],
    },
    {
      seriesTitle: "Biographical Works",
      description: "Black Lotus: The Spiritual Journey of an Urban Mystic explores the life and mission of B.T. Swami, an African-American seeker who became one of the most influential spiritual leaders of the twentieth century. His inspiring story is enriched by personal interviews with family, friends, college professors, mentors, students, and other fellow travellers on the spiritual path. These interviews make their appearance in the book as inset quotes, allowing his associates to speak for themselves. As a result, Black Lotus offers an intimate look at the Swami’s life and times, which blossom on these pages for the first time in written form. As the beauty and sublime perfection of a lotus rises in supreme majesty above its stem, which is buried deeply in clouded waters, so Black Lotus is a tribute to one who rose above all boundaries and limitations, and inspired others to do the same.",
      books: [
        {
          title: "Black Lotus",
          subtitle: "The Spiritual Journey of an Urban Mystic",
          image: bl,
          link: "https://www.amazon.com/Black-Lotus-Spiritual-Journey-Mystic/dp/B0882MRKK1",
        },
      ],
    },
    {
      seriesTitle: "Journey Home & Journey Withnin",
      description: "Radhanath Swami is a disciple of A.C. Bhaktivedanta Swami Prabhupada (1896–1977). In dedication to the vision of his spiritual master, he has devoted his life to spreading God consciousness through compassionate outreach, spiritual education, community building, and service initiatives like hospitals for the elderly, providing one time lunch in schools, etc. that uphold the principles of devotion, humility, and respect for all living beings.Bhakti Tirtha Swami and Radhanath Swami were spiritual brothers and close friends, united by deep mutual respect, a shared dedication to devotional service, and harmonious spiritual goals, even while engaged in different forms of service. Having met in the early 1970s, Radhanath Swami was profoundly inspired by Bhakti Tirtha Swami, who remained a guiding light for him even during his final days.",
      books: [
        {
          title: "The Journey Home",
          subtitle: "Autobiography of an American Swami",
          image: jhome,
          link: "https://www.amazon.com/gp/product/1601090560/ref=ewc_pr_img_2?smid=ATVPDKIKX0DER&psc=1",
        },
        {
          title: "The Journey Within",
          subtitle: "Exploring the Path of Bhakti",
          image: jwithnin,
          link: "https://www.amazon.com/gp/product/1608871576/ref=ewc_pr_img_1?smid=A26HV0I005AGDF&psc=1",
        },
      ],
    },
  ];
  
  const BooksPage = () => (
    <>
        <Navbar />
        <PageHeader title="His Holiness Bhakti Tirtha Swami Books" path="/books" name="Books" />
        <div className="books-page">
            <h1 className="books-heading">Books by His Holiness Bhakti Tirtha Swami</h1>
            <p className="books-intro">
                Bhakti Tirtha Swami authored several books on conscious leadership, spiritual warriorhood, and Vedic philosophy. His writings blend deep spiritual insights with practical wisdom for modern living. Explore and be inspired.
            </p>
        
            {bookSeries.map((series, index) => (
                <section key={index} className="book-series-section">
                  <h2 className="series-title">{series.seriesTitle}</h2>
                  <p className="series-description">{series.description}</p>
                  <div className="books-grid">
                      {series.books.map((book, i) => (
                      <div className="book-card" key={i}>
                          <img src={book.image} alt={book.title} className="book-image" />
                          <div className="book-details">
                          <h3 className="book-title">{book.title}</h3>
                          <p className="book-subtitle">{book.subtitle}</p>
                          <a href={book.link} target="_blank" rel="noreferrer" className="book-button">
                              Purchase
                          </a>
                          </div>
                      </div>
                      ))}
                  </div>
                </section>
            ))}
        </div>
        <Footer />
        <BackToTop />
    </>
  );
  
  export default BooksPage;
  
